import API from './jsonapi-constants'

export const CONSTANTS = {
  ATTRIBUTE: {
    ID: 'media.id',
    DOMAIN: 'media.domain',
    LABEL: 'media.label',
    LANGUAGEID: 'media.languageid',
    MIMETYPE: 'media.mimetype',
    PREVIEW: 'media.preview',
    PREVIEWS: 'media.previews',
    STATUS: 'media.status',
    TYPE: 'media.type',
    URL: 'media.url',
  },
  TYPE: {
    DATASHEET: 'datasheet',
    DEFAULT: 'default',
    THREESIXTY: '360',
    EXPLODED_DRAWING: 'ex',
  },
}

export const PATHS = {
  ID: [API.ATTRIBUTES, CONSTANTS.ATTRIBUTE.ID],
  LABEL: [API.ATTRIBUTES, CONSTANTS.ATTRIBUTE.LABEL],
  LANGUAGEID: [API.ATTRIBUTES, CONSTANTS.ATTRIBUTE.LANGUAGEID],
  MIMETYPE: [API.ATTRIBUTES, CONSTANTS.ATTRIBUTE.MIMETYPE],
  PREVIEW: [API.ATTRIBUTES, CONSTANTS.ATTRIBUTE.PREVIEW],
  PREVIEWS: [API.ATTRIBUTES, CONSTANTS.ATTRIBUTE.PREVIEWS],
  STATUS: [API.ATTRIBUTES, CONSTANTS.ATTRIBUTE.STATUS],
  TYPE: [API.ATTRIBUTES, CONSTANTS.ATTRIBUTE.TYPE],
  URL: [API.ATTRIBUTES, CONSTANTS.ATTRIBUTE.URL],
}

export default {
  ...CONSTANTS,
  PATHS,
}
